<template>
  <div class="card">
    <a-typography-text class="card__title" strong>{{ props.title }}</a-typography-text>
    <a-tooltip :title="props.number" placement="bottom">
      <p class="card__content">
        <icon-channel v-if="props.channel" :type="props.channel" :width="20" />
        {{ shortNumber(props.number) }}
      </p>
    </a-tooltip>
    <div :class="`card__bottom card__bottom--${props.color}`" />
  </div>
</template>

<script setup lang="ts">
import { shortNumber } from "@/app/dashboard/utils/shortNumber";
import IconChannel from "@/app/shared/components/icons/IconChannel.vue";

const props = defineProps({
  title: { type: String, required: true },
  number: { type: Number, required: true },
  color: {
    type: String,
    enum: ["cyan", "blue", "orange", "lime", "purple", "volcano", "green"],
    required: true,
  },
  channel: {
    type: Number,
    required: false,
  },
});
</script>

<style lang="sass" scoped>
.card
  width: 9vw
  height: 100%
  background: $gray-2
  border-radius: 8px
  text-align: center
  display: flex
  flex-direction: column
  justify-content: space-between
  color: $gray-9
  font-size: 14px
  line-height: 20px
  &__title
    margin-top: 10px
  &__content
    margin-top: 10px
    font-size: 18px
    color: $gray-8
    cursor: pointer
  &__bottom
    border-radius: 0px 0px 8px 8px
    width: 100%
    height: 10px
    &--blue
      background: $blue-3
    &--cyan
      background: $cyan-3
    &--orange
      background: $orange-3
    &--lime
      background: $lime-3
    &--green
      background: $green-3
    &--purple
      background: $purple-3
    &--magenta
      background: $magenta-3
    &--volcano
      background: $volcano-3
</style>
